import { MutationTree } from "vuex";
import { SnackbarState } from "./types";

export const mutations: MutationTree<SnackbarState> = {
  showSnackbar(state, payload) {
    state.content = payload.content;
    state.color = payload.color;
  }
};
